import { REACT_APP_PUBLIC_DIRECTUS_API } from '@/constants';
import { createDirectus, rest, authentication, readMe } from '@directus/sdk';

class LocalStorage {
    get() {
        return JSON.parse(localStorage.getItem("directus-data") || "");
    }
    set(data: any) {
        localStorage.setItem("directus-data", JSON.stringify(data));
    }
}

export const storage = new LocalStorage();

export const directus = createDirectus(
    REACT_APP_PUBLIC_DIRECTUS_API
)
    .with(
        authentication("cookie", {
            autoRefresh: true,
            credentials: "include",
            msRefreshBeforeExpires: 1000 * 60 * 1,
            storage,
        })
    )
    .with(rest({ credentials: "include" }));

export const getCurrentUserId = async () => {
    try {
        const me = await directus.request(readMe());
        return me?.id;
    } catch {
        return undefined;
    }
};

export const logoutUser = async () => {
    try {
        await directus.logout();
    } catch (error) {
        console.error('Logout error:', error);
    }
};

export const refreshAuthToken = async () => {
    await directus.refresh();
};

export default directus;
